
export default ({ app, context }, inject) => {
    //MUST install and enable [nuxt-user-agent] !
    const browser = {
        name: {
            IE: 'Internet Explorer',
            Firefox: 'Firefox',
            ME: 'Edge',
            Chrome: 'Chrome',
        },
        isIE: function (){
            return app.$ua.browser() == this.name.IE;
        },
        isFirefox: function (){
            return app.$ua.browser() == this.name.Firefox;
        },
        isChrome: function (){
            return app.$ua.browser() == this.name.Chrome;
        },
        isME: function (){
            return app.$ua.browser() == this.name.ME;
        },
    }
    inject('browser', browser);
}